module.exports = __webpack_public_path__ + "img/konfigurasi.e0a9c162.png";